import { useCallback, useMemo } from 'react'
import { NAME_OF_PRODUCT_TYPES, REQUIRED_FEATURE_FLAGS } from 'helpers/sf_constants'
import useFeatureFlagsForAccounts from './useFeatureFlagsForAccounts'

const useLeadMarketplace = account => {
  const [isFeatureFlagActiveForAccount] = useFeatureFlagsForAccounts()
  const isLeadMarketplaceEnabled = useMemo(() => {
    if (!account) {
      return false
    }

    return isFeatureFlagActiveForAccount(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_GOAL_MARKETPLACE, account)
  }, [account, isFeatureFlagActiveForAccount])

  const isLeadMarketplaceProduct = useCallback(productTypeName => (
    productTypeName?.toLowerCase() === NAME_OF_PRODUCT_TYPES.LEADS &&
    isLeadMarketplaceEnabled
  ), [isLeadMarketplaceEnabled])

  return { isLeadMarketplaceEnabled, isLeadMarketplaceProduct }
}

export default useLeadMarketplace
